<template>
    <div class="fillcontain">
      <el-form ref="form" label-width="180px">
        <el-form-item :label="item.name+':'" v-for="(item,key) in settings" :key="key">
          <el-switch
            v-if="item.type == 1"
            v-model="item.valueStr"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-text="item.settingParams[0].name"
            :inactive-text="item.settingParams[1].name"
            :active-value="item.settingParams[0].value"
            :inactive-value="item.settingParams[1].value"
            @change="save(item.valueKey,item.valueStr)"
          >
          </el-switch>
          <el-select  v-if="item.type == 2" v-model="item.valueStr" placeholder="请选择" @change="save(item.valueKey,item.valueStr)">
            <el-option
              v-for="ite in item.settingParams"
              :key="ite.value"
              :label="ite.name"
              :value="ite.value">
            </el-option>
          </el-select>
          <el-input v-if="item.type == 3" v-model="item.valueStr" @focusout="save(item.valueKey,item.valueStr)"></el-input>
          <el-input-number v-if="item.type == 4" v-model="item.valueStr" @change="save(item.valueKey,item.valueStr)"></el-input-number>
          <el-alert
            :title="item.note"
            type="success">
          </el-alert>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>

    export default {
        data(){
            return {
                loading:false,
                settings:[],
            }
        },
        created(){
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/store/setting', null, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.settings = res.data.settings;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },
          save(key,value) {
                this.loading = true;
                var that = this;
                that.$api.put('/store/setting/'+key, {"value":value}, response => {
                  if (response.status >= 200 && response.status < 300) {
                    console.log(response.data);
                    var res = response.data;
                    if (res.code == 0) {
                      this.$message({
                        message: '修改成功',
                        type: 'success'
                      });
                    }else{
                      this.$message({
                        message: res.msg,
                        type: 'warning'
                      });
                    }
                  } else {
                    this.$message({
                      message: "服务器维护中",
                      type: 'error'
                    });
                  }

                });

                this.loading = false;
            },
        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/store/Setting.vue